import Vue from 'vue';
import App from './App.vue';
import router from './router';
import 'vue-class-component/hooks';
import VueI18n from 'vue-i18n';
import VueSelect from "vue-select";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import i18nMessages from "@/i18nMessages";
import Multiselect from "vue-multiselect";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import VueQRCodeComponent from 'vue-qrcode-component';

import "@/app.scss";
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueI18n);

Vue.use(CKEditor);

Vue.component("v-select", VueSelect);
Vue.component("v-multiselect", Multiselect);
Vue.component('v-datepicker', VueDatepickerUi);
Vue.component('v-chart', async () => {
  await import("@/echarts");
  return import("vue-echarts");
});

Vue.component('qr-code', VueQRCodeComponent);


Vue.config.productionTip = false;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: localStorage.getItem("vue-i18n-locale") || "vi", // set locale
  messages: i18nMessages, // set locale messages
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
